export default __webpack_public_path__ + "static/media/cx_cover_c30.c047b69d.jpg";